// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ImageCarousel_carousel__sfq9i"};